const ProjectManagerDashboard = () => {
    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h1 style={styles.title}>Project Manager Dashboard</h1>
                <p style={styles.text}>
                    This dashboard is ready for the `PROJECT_MANAGER` role. We can add project-level KPIs,
                    progress tracking, and quick actions here next.
                </p>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: "100vh",
        background: "#f7f7fb",
        padding: 24
    },
    card: {
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 18,
        padding: 28,
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)"
    },
    title: {
        margin: 0,
        fontSize: 28,
        fontWeight: 800,
        color: "#111827"
    },
    text: {
        marginTop: 12,
        marginBottom: 0,
        fontSize: 15,
        color: "#4b5563",
        lineHeight: 1.6
    }
};

export default ProjectManagerDashboard;
